import React from 'react'
import Testimonial from '../elements/Testimonial'

export default class Testimonials extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    const { title, list } = this.props.testimonial
    return (
      <div className="section section-testimonails cb-light-bgcolor" id="testimonials">
        <div className="container">
          <div className="row">
            <h2 className="xl-font-size font-weight__500 text-center w-100">
              {title ? title : "Team"}
            </h2>
            <div className="col-12 col-md-12 mx-auto">
              <div className="align-items-center">
                <div className="lw-wrapper-testi w-100 mw-100">
                  {list.length > 0 ?
                    <div className="row">
                      {
                        list.map((listItem, key) => (
                          <Testimonial {...listItem} key={key} index={key} />
                        ))
                      }
                    </div>
                    :
                    null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}
